if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const variantId = this.form.querySelector('[name="id"]')?.value;
        if (!variantId || Number.isNaN(parseInt(variantId, 10))) {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          return;
        }
        const isCartDrawerRecommendation = this.dataset.sectionId === 'cart-drawer-recommendations';
        const quantityInput =
          this.form.querySelector('[name="quantity"]') ||
          document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
        // Use quantity from selected variant option (1, 3, 6 etc.) so first add-to-cart is correct
        // Cart drawer recommendations always add qty 1 and skip bundle popup
        let quantity = 1;
        if (!isCartDrawerRecommendation) {
          quantity = parseInt(quantityInput?.value, 10) || 1;
          const selectedVirtualVariant = document.querySelector('.phi--virtual-variant.phi--virtual-variant-selected');
          if (selectedVirtualVariant && selectedVirtualVariant.dataset.quantity) {
            const qty = parseInt(selectedVirtualVariant.dataset.quantity, 10);
            if (qty > 0) quantity = qty;
          } else {
            const checkedVariantRadio = document.querySelector('.input-label input[type="radio"]:checked');
            const variantContainer = checkedVariantRadio?.closest('.input-label');
            if (variantContainer?.dataset.quantity) {
              const qty = parseInt(variantContainer.dataset.quantity, 10);
              if (qty > 0) quantity = qty;
            }
          }
          if (quantityInput && quantityInput.value != quantity) {
            quantityInput.value = quantity;
          }
        }
        const sellingPlanId = this.getCurrentSellingPlanId();

        const item = {
          id: parseInt(variantId, 10),
          quantity,
        };
        if (sellingPlanId) {
          item.selling_plan = parseInt(sellingPlanId, 10);
        }

        const body = {
          items: [item],
        };
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
          if (!sellingPlanId) {
            body.sections = this.cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }
        }

        const cartAddPath =
          typeof routes !== 'undefined' && routes.cart_add_url
            ? String(routes.cart_add_url)
            : '/cart/add';
        const addUrl =
          cartAddPath.startsWith('/') && cartAddPath.includes('cart')
            ? cartAddPath.replace(/\/cart\/add\/?$/, '/cart/add.js')
            : '/cart/add.js';
        const bodyString = JSON.stringify(body);

        const cartAddPromise = sellingPlanId
          ? new Promise((resolve, reject) => {
              const xhr = new XMLHttpRequest();
              xhr.open('POST', addUrl, true);
              xhr.setRequestHeader('Content-Type', 'application/json');
              xhr.setRequestHeader('Accept', 'application/json');
              xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
              xhr.onload = () => {
                if (xhr.status < 200 || xhr.status >= 400) {
                  reject(new Error(`Cart add failed: ${xhr.status} ${xhr.statusText}`));
                  return;
                }
                try {
                  resolve(JSON.parse(xhr.responseText));
                } catch (e) {
                  reject(e);
                }
              };
              xhr.onerror = () => reject(new Error('Cart add network error'));
              xhr.send(bodyString);
            })
          : fetch(addUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: bodyString,
            }).then((response) => {
              if (!response.ok) {
                throw new Error(`Cart add failed: ${response.status} ${response.statusText}`);
              }
              return response.json();
            });

        cartAddPromise.then((response) => {
            const itemData = response.items?.[0] ?? response;
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const doRender = (data) => {
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => this.cart.renderContents(data), 0);
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(data);
              }
            };

            const popup = document.querySelector('.bundle-popup-wrapper');
            const overlay = document.querySelector('.bundle-popup-overlay');
            const closeButton = document.querySelector('.no-thanks');
            // Skip bundle popup for cart drawer recommendation add-to-cart (add directly to drawer)
            const showBundlePopupFirst = !isCartDrawerRecommendation && popup && overlay;

            function openPopup() {
              if (popup) popup.classList.remove('hidden');
              if (overlay) overlay.classList.remove('hidden');
              document.body.classList.add('body-fixed');
            }

            function closePopup() {
              if (popup) popup.classList.add('hidden');
              if (overlay) overlay.classList.add('hidden');
              document.body.classList.remove('body-fixed');
            }

            const openCartDrawerWithData = (data) => {
              if (!data.sections && this.cart && typeof routes !== 'undefined' && routes.cart_url) {
                const sectionIds = this.cart.getSectionsToRender().map((s) => s.id);
                Promise.all(
                  sectionIds.map((id) =>
                    fetch(`${routes.cart_url}?section_id=${id}`, { cache: 'no-store' }).then((r) => r.text())
                  )
                )
                  .then((htmls) => {
                    const sections = {};
                    sectionIds.forEach((id, i) => {
                      sections[id] = htmls[i];
                    });
                    doRender({ ...data, sections });
                  })
                  .catch(() => doRender(data));
              } else {
                doRender(data);
              }
            };

            if (showBundlePopupFirst) {
              const whenDataReady = (data) => {
                const onNoThanksOrOverlay = () => {
                  closePopup();
                  openCartDrawerWithData(data);
                };
                openPopup();
                overlay && overlay.addEventListener('click', onNoThanksOrOverlay, { once: true });
                closeButton && closeButton.addEventListener('click', onNoThanksOrOverlay, { once: true });
              };
              if (!response.sections && this.cart && typeof routes !== 'undefined' && routes.cart_url) {
                const sectionIds = this.cart.getSectionsToRender().map((s) => s.id);
                Promise.all(
                  sectionIds.map((id) =>
                    fetch(`${routes.cart_url}?section_id=${id}`, { cache: 'no-store' }).then((r) => r.text())
                  )
                )
                  .then((htmls) => {
                    const sections = {};
                    sectionIds.forEach((id, i) => {
                      sections[id] = htmls[i];
                    });
                    whenDataReady({ ...response, sections });
                  })
                  .catch(() => whenDataReady(response));
              } else {
                whenDataReady(response);
              }
            } else {
              if (!response.sections && this.cart && typeof routes !== 'undefined' && routes.cart_url) {
                const sectionIds = this.cart.getSectionsToRender().map((s) => s.id);
                Promise.all(
                  sectionIds.map((id) =>
                    fetch(`${routes.cart_url}?section_id=${id}`, { cache: 'no-store' }).then((r) => r.text())
                  )
                )
                  .then((htmls) => {
                    const sections = {};
                    sectionIds.forEach((id, i) => {
                      sections[id] = htmls[i];
                    });
                    doRender({ ...response, sections });
                  })
                  .catch(() => doRender(response));
              } else {
                doRender(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      /**
       * Returns the currently selected selling plan ID if "Subscribe & Save" is selected, else null.
       * Uses the same value set in global.js updateSelectionMetadata when user selects a subscription option.
       */
      getCurrentSellingPlanId() {
        const purchaseTypeRadios = document.querySelectorAll('input[name="purchase_type"]');
        const isSubscription =
          purchaseTypeRadios.length > 0 &&
          Array.from(purchaseTypeRadios).findIndex((r) => r.checked) === 1;

        if (!isSubscription) return null;

        if (this.form.dataset.currentSellingPlanId) return this.form.dataset.currentSellingPlanId;

        const existingInput = this.form.querySelector('input[name="selling_plan"]');
        if (existingInput && existingInput.value) return existingInput.value;

        const subscriptionContainer = document.querySelector('.subscription-variant');
        if (subscriptionContainer && subscriptionContainer.classList.contains('hidden')) return null;

        const checkedRadio = subscriptionContainer
          ? subscriptionContainer.querySelector('.pi-selling-plan-option input[type="radio"]:checked')
          : document.querySelector('.pi-selling-plan-option input[type="radio"]:checked');
        if (checkedRadio) {
          const optionEl = checkedRadio.closest('.pi-selling-plan-option');
          const planId = (optionEl && optionEl.getAttribute('selling-plan-id')) || checkedRadio.value;
          if (planId) return planId;
        }

        const urlPlan = new URLSearchParams(window.location.search).get('selling_plan');
        if (urlPlan) return urlPlan;

        return null;
      }
    }
  );
}
